export default __webpack_public_path__ + "static/media/T560_RoHS.d776bace.pdf";